import React from 'react';

import { RadioGroup as MuiRadioGroup, Radio } from '@mui/material';

import { RadioFormControl } from './RadioFormControl';
import { IRadioGroupProps as IProps } from './types';

export const RadioGroup: React.FC<IProps> = ({ value, onChange, options }) => (
  <MuiRadioGroup value={value} onChange={onChange}>
    {options.map(({ label, value }) => (
      <RadioFormControl key={value} value={value} label={label} control={<Radio />} />
    ))}
  </MuiRadioGroup>
);
